query GetFundGroup($id: ID!) {
  fundGroup(id: $id) {
    id
    name
    salesforceId
    funds {
      id
      name
      fundRecordType {
        id
        name
      }
      legalEntity {
        id
        name
      }
    }
  }
}
